import PaginatedList from 'commons/views/PaginatedList.js';
import Attachments from 'newCollections/attachments.js';

var template = require('employee/templates/payslips/Payslips.ejs');

module.exports = PaginatedList.extend({

    initialize: function(options) {
        //FIXME NEVER extend this with options
        _.extend(this, options);
        this.delegateEvents();
        this.collection = options.payslips;
        this.collection.on('sync', this.render, this);
        this.collection.fetchPage(undefined, {validate: false});
        this.render();
    },

    events: function() {
        return PaginatedList.prototype.events.apply(this);
    },

    render: function() {
        if (this.payslips.length <= 0) {   
            this.$el.html(template({
                payslips:    this.payslips,
                pagination:  this.collection.pagination
            }));
        }
        const getAttachments =  Promise.all(this.payslips.map(payslip => {
            return new Attachments(null, {
                attachable: payslip,
            }).fetch({filter: { order: 'createdAt DESC'}
            }).then((attach) => {
                return [
                    payslip.id,
                    attach
                ]
            })
        }))
        getAttachments.then(attachments => {
            return Promise.resolve(_.object(attachments));
        }).then(attachments => {
            this.$el.html(template({
                payslips:    this.payslips,
                attachments: attachments,
                pagination:  this.collection.pagination
            }));
        })
        
        return this;
    }
});



// WEBPACK FOOTER //
// ./app/employee/views/payslips/Payslips.js